import React from "react";
import Header from "../components/Header";

export default function WarehousingAndMaterials() {
  return (
    <>
    <Header />
    <div className="w-full min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 p-4 md:p-6 font-sans">
      <div className="max-w-7xl mx-auto bg-white shadow-2xl p-6 md:p-8 rounded-2xl">
        {/* Enhanced Header */}
        <div className="flex items-center space-x-4 md:space-x-6">
          <div className="relative">
            <div className="w-12 h-24 bg-gradient-to-b from-blue-500 to-blue-800 rounded-xl shadow-lg"></div>
            <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-green-500 rounded-full border-4 border-white"></div>
          </div>
          <div>
            <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent">
              3-Warehousing & Materials Management
            </h1>
            <p className="text-sm md:text-base text-blue-700 mt-2">
              End-to-End Material Lifecycle & Inventory Control Platform
            </p>
          </div>
        </div>

        {/* Enhanced System Description */}
        <div className="mt-8 bg-gradient-to-r from-blue-900 to-blue-700 text-white rounded-2xl shadow-xl p-6 md:p-8">
          <div className="flex items-center gap-3 mb-6">
            <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
            </svg>
            <h2 className="text-2xl font-bold">Comprehensive Lifecycle Management</h2>
          </div>
          <p className="text-base md:text-lg leading-relaxed">
            The platform provides comprehensive lifecycle management, covering the entire material process including
            intelligent coding, procurement, inspection, inbound/outbound logistics, and returns. Enables full-process
            monitoring with real-time visibility, facilitating holistic control of material resources across all project stages.
          </p>
          <div className="flex flex-wrap gap-3 mt-6">
            <span className="px-4 py-2 bg-blue-600 rounded-full text-sm font-medium">Smart Coding</span>
            <span className="px-4 py-2 bg-blue-600 rounded-full text-sm font-medium">Real-time Tracking</span>
            <span className="px-4 py-2 bg-blue-600 rounded-full text-sm font-medium">Inventory Optimization</span>
            <span className="px-4 py-2 bg-blue-600 rounded-full text-sm font-medium">Quality Control</span>
          </div>
        </div>

        {/* Enhanced Scenario Description */}
        <div className="mt-8 bg-gradient-to-r from-green-50 to-white rounded-2xl shadow-lg p-6 md:p-8 border border-green-100">
          <div className="flex items-center gap-3 mb-6">
            <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
            </svg>
            <h2 className="text-2xl font-bold text-green-900">Integrated Application Scenarios</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-green-100 to-white p-5 rounded-xl shadow-md border border-green-200">
              <h3 className="font-bold text-green-900 mb-3 flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z" clipRule="evenodd" />
                </svg>
                Material Management & Control
              </h3>
              <p className="text-sm text-gray-600">
                Centralized control of engineering project materials with real-time inventory visibility and automated reordering.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-100 to-white p-5 rounded-xl shadow-md border border-blue-200">
              <h3 className="font-bold text-blue-900 mb-3 flex items-center gap-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
                </svg>
                Cross-System Integration
              </h3>
              <p className="text-sm text-gray-600">
                Providing data support for logistics distribution, pipe prefabrication, and construction management systems.
              </p>
            </div>
          </div>
        </div>

        {/* Enhanced Workflow Visualization */}
        <div className="mt-10">
          <div className="rounded-2xl shadow-xl overflow-hidden bg-gradient-to-br from-gray-50 to-white border border-gray-200">
            <div className="bg-gradient-to-r from-blue-800 to-blue-600 text-white py-4 px-6 font-bold">
              <div className="flex items-center gap-3">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                </svg>
                Material Workflow Dashboard
              </div>
            </div>
            <div className="p-4 md:p-6">
              <img
                src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
                alt="Warehouse Management Dashboard"
                className="w-full h-72 object-cover rounded-lg shadow-md"
              />
              <div className="mt-4 p-4 bg-blue-50 rounded-lg">
                <p className="text-sm text-gray-600">
                  Real-time visualization of material flow from procurement to distribution with interactive tracking and analytics.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Lifecycle Management */}
        <div className="mt-12 text-center">
          <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent">
            Comprehensive Lifecycle Management of Materials
          </h2>
          <p className="text-gray-600 mt-3">End-to-end visibility and control across the entire material ecosystem</p>
        </div>

        {/* Integration Points */}
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          {[
            { label: "Urgent Distribution Logistics", icon: "🚚" },
            { label: "System Interface", icon: "🔗" },
            { label: "Warehouse Management", icon: "🏢" },
            { label: "Smart Linkage", icon: "⚡" },
            { label: "Pipe Prefabrication", icon: "🔧" }
          ].map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-3 transform transition-transform group-hover:scale-105">
                <span className="text-lg">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Dual Loop Management */}
        <div className="mt-10 text-center">
          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white px-8 py-4 rounded-xl shadow-lg">
            <div className="flex items-center justify-center gap-3 font-bold text-lg">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                <path d="M4.293 5.293a1 1 0 011.414 0L10 9.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z" />
              </svg>
              Dual Closed-Loop Management
            </div>
            <p className="text-sm opacity-90 mt-2">
              Synchronized order and business process management with automated validation
            </p>
          </div>
        </div>

        {/* Enhanced Process Flow */}
        <div className="mt-12 bg-gradient-to-r from-gray-50 to-blue-50 rounded-2xl p-6 md:p-8 border border-blue-100">
          <h3 className="text-xl font-bold text-blue-900 mb-8 text-center">End-to-End Material Process Flow</h3>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {[
              { step: "Order-Contract", icon: "📝" },
              { step: "Receiving Note", icon: "📋" },
              { step: "Goods Inspection", icon: "🔍" },
              { step: "Inbound Completion", icon: "📥" },
              { step: "Inventory Management", icon: "📊" },
              { step: "Material Application", icon: "📄" },
              { step: "Material Transfer", icon: "🔄" },
              { step: "Material Isolation", icon: "🚫" },
              { step: "Material Distribution", icon: "🚚" },
              { step: "Materials Simulation", icon: "🎯" }
            ].map((item, i) => (
              <div key={i} className="group cursor-pointer">
                <div className="bg-white p-4 rounded-xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow text-center">
                  <div className="text-2xl mb-2">{item.icon}</div>
                  <div className="text-sm font-medium text-gray-800">{item.step}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Key Features */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl shadow-md border border-blue-100">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Real-time Inventory</h3>
            <p className="text-sm text-gray-600">Live inventory tracking with automated stock level monitoring</p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-white p-6 rounded-xl shadow-md border border-green-100">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Quality Assurance</h3>
            <p className="text-sm text-gray-600">Automated inspection workflows with digital sign-off</p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-white p-6 rounded-xl shadow-md border border-purple-100">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
            </div>
            <h3 className="font-bold text-gray-800 mb-2">Predictive Analytics</h3>
            <p className="text-sm text-gray-600">AI-powered demand forecasting and optimization</p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-white p-5 rounded-xl shadow-md border border-blue-100 text-center">
            <div className="text-2xl font-bold text-blue-800">99%</div>
            <div className="text-sm text-gray-600">Inventory Accuracy</div>
          </div>
          <div className="bg-white p-5 rounded-xl shadow-md border border-blue-100 text-center">
            <div className="text-2xl font-bold text-blue-800">60%</div>
            <div className="text-sm text-gray-600">Process Efficiency</div>
          </div>
          <div className="bg-white p-5 rounded-xl shadow-md border border-blue-100 text-center">
            <div className="text-2xl font-bold text-blue-800">30%</div>
            <div className="text-sm text-gray-600">Cost Reduction</div>
          </div>
          <div className="bg-white p-5 rounded-xl shadow-md border border-blue-100 text-center">
            <div className="text-2xl font-bold text-blue-800">24/7</div>
            <div className="text-sm text-gray-600">System Availability</div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}